import {connect, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import Loading from "../../common/Loading";
import * as api from "../../../api/api";
import {AgGridReact} from "ag-grid-react";
import * as Global from "../../common/Global";
import {CModal, CModalBody} from "@coreui/react";
import BettingDetail from "./BettingDetail";
import dayjs from "dayjs";
import InputRangeDate from "../../common/InputRangeDate";
import {useSearchParams} from "react-router-dom";
import {StandardListPage} from "../../../components/StandardListPage";

const MinigameBettingList = ({ paramUserId = '', embedded = false }) => {
    const {user} = useSelector((props) => props.account);
    const [searchParams] = useSearchParams();
    const initialUserId = paramUserId || searchParams.get('userId') || '';

    const [loading, setLoading] = useState(false)
    const [searchForm, setSearchForm] = useState({
        fromDate: dayjs(),
        toDate: dayjs(),
        userId: initialUserId
    })
    const [dataList, setDataList] = useState([])
    const [modal, setModal] = useState(false)
    const [selectedRow, setSelectedRow] = useState({})
    const [sumData, setSumData] = useState({
        totalBettingAmount: 0, totalWinningAmount: 0, totalFee: 0, totalProfit: 0
    })

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true,
        suppressMenu: true,
        suppressHeaderMenuButton: true
    };

    const [columnDefs] = useState([
        {field: 'No', headerName: '번호', width: 60, valueGetter: 'node.rowIndex + 1', cellClass: 'static-cell'},
        {field: 'seq', headerName: 'No', width: 40, hide: true},
        {
            field: 'bettingUserId',
            headerName: "아이디",
            width: 180,
            cellStyle: { cursor: 'pointer', color: '#3B82F6', fontWeight: 'bold' },
            valueGetter: (params) => params.data ? `${params.data.bettingUserId} (${params.data.nickName || ''})` : ''
        },
        {field: 'minigameName', headerName: "게임구분", width: 120, cellClass: 'static-cell'},
        {field: 'dateRound', headerName: "회차", width: 80, cellClass: 'static-cell'},
        {field: 'gameName', headerName: "게임종류", width: 120, cellClass: 'static-cell'},
        {field: 'holeName', headerName: "베팅", width: 120, cellClass: 'static-cell'},
        {
            field: 'instTime',
            headerName: "배팅시각",
            width: 180,
            cellClass: 'static-cell',
            valueFormatter: (params) => params.value ? dayjs(params.value).format('YYYY-MM-DD HH:mm:ss') : ''
        },
        {field: 'holeOdds', headerName: "배당", width: 80, cellClass: 'number-cell'},
        {field: 'userBalance', headerName: "베팅전 금액", width: 100, valueFormatter: Global.currencyFormatter, cellClass: 'number-cell'},
        {field: 'bettingAmount', headerName: "배팅금", width: 100, valueFormatter: Global.currencyFormatter, cellClass: 'number-cell'},
        {headerName: "베팅후 금액", width: 100,
            valueGetter: params => params.data.userBalance - params.data.bettingAmount + params.data.bettingWinningAmount,
            valueFormatter: Global.currencyFormatter,
            cellClass: 'text-green-600 number-cell'
        },
        {field: 'bettingWinningAmount', headerName: "당첨금", width: 100, valueFormatter: Global.currencyFormatter, cellClass: 'number-cell'},
        {
            field: 'result',
            headerName: "승패",
            width: 100,
            cellClass: 'static-cell',
            valueGetter: e => {
                if (e.data.result === '0') return '대기중'
                if (e.data.result === '1') return '승'
                if (e.data.result === '2') return '패'
                return ''
            },
            cellStyle: params => {
                if (params.data.result === '1') return { color: 'green' }
                if (params.data.result === '2') return { color: 'red' }
                return null
            }
        }
    ])

    useEffect(() => {
        search()
    }, [])

    const handleWhere = (e) => {
        const {name, value} = e.target;
        setSearchForm({ ...searchForm, [name]: value })
    }

    const search = () => {
        const params = {
            companyCode: user.companyCode,
            rootUserId: user.rootUserId,
            fromDate: searchForm.fromDate.format("YYYYMMDD"),
            toDate: searchForm.toDate.format("YYYYMMDD"),
            userId: searchForm.userId
        }
        setLoading(true)
        api.getMinigameBettingList(params).then(result => {
            const {data, status} = result;
            if (status === 200) {
                setDataList(data)
                const totalBettingAmount = data.reduce((sum, row) => sum + (row.bettingAmount || 0), 0)
                const totalWinningAmount = data.reduce((sum, row) => sum + (row.bettingWinningAmount || 0), 0)
                const totalFee = data.reduce((sum, row) => sum + (row.fee || 0), 0)
                setSumData({
                    totalBettingAmount,
                    totalWinningAmount,
                    totalFee,
                    totalProfit: totalBettingAmount - totalWinningAmount - totalFee
                })
            }
        })
            .catch(ex => window.alert(ex.message))
            .finally(() => setLoading(false))
    }

    const onCellClicked = (params) => {
        if (params.column.colId === 'bettingUserId') {
            handleUserClick(params.data);
        }
    }

    const handleUserClick = (data) => {
        const params = "userId=" + data.bettingUserId + "&procUserId=" + user.userId
        const popup = window.open('/#/user/detail?' + params, "_user-detail", "width=1500, height=800");
        if (popup) popup.focus();
    }

    const handleDate = (date) => {
        setSearchForm({ ...searchForm, fromDate: date[0], toDate: date[1] })
    }

    const filterContent = (
        <>
            <InputRangeDate title="날짜" startTime={searchForm.fromDate} endTime={searchForm.toDate} setValue={handleDate} />
            <input
                className="h-7 px-2 w-40 text-xs border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                name="userId"
                value={searchForm.userId}
                onChange={handleWhere}
                onKeyPress={e => e.key === "Enter" && search()}
                placeholder="회원ID"
            />
            <button className="h-7 px-3 bg-gray-600 text-white text-xs font-medium" onClick={search}>조회</button>
        </>
    );

    const gridContent = (
        <>
            <div className="grid grid-cols-4 gap-0 py-2.5 px-3 bg-slate-500 border-b border-slate-600 text-sm">
                <div className="text-slate-100 font-medium text-center">총 배팅금액 <span className="block mt-0.5"><strong className="text-red-200 font-bold text-base">{sumData.totalBettingAmount.toLocaleString()}</strong></span></div>
                <div className="text-slate-100 font-medium text-center border-l border-slate-400">총 당첨금액 <span className="block mt-0.5"><strong className="text-blue-200 font-bold text-base">{sumData.totalWinningAmount.toLocaleString()}</strong></span></div>
                <div className="text-slate-100 font-medium text-center border-l border-slate-400">총 수수료 <span className="block mt-0.5"><strong className="text-amber-200 font-bold text-base">{sumData.totalFee.toLocaleString()}</strong></span></div>
                <div className="text-slate-100 font-medium text-center border-l border-slate-400">수익 <span className="block mt-0.5"><strong className="text-emerald-200 font-bold text-base">{sumData.totalProfit.toLocaleString()}</strong></span></div>
            </div>
            <div className="ag-theme-alpine h-[calc(100vh-350px)] overflow-hidden mt-1">
                <AgGridReact
                    rowHeight={36}
                    headerHeight={32}
                    rowData={dataList}
                    pagination={true}
                    enableCellTextSelection={true}
                    enableRangeSelection={true}
                    suppressClipboardPaste={true}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}
                    onCellClicked={onCellClicked}
                    onGridReady={(params) => params.api.sizeColumnsToFit()}
                />
            </div>
        </>
    );

    if (embedded) {
        return (
            <>
                {loading ? <Loading /> : null}
                <div className="bg-white border border-gray-200">
                    <div className="px-2 py-2 border-b border-gray-100 flex flex-wrap items-center gap-2">
                        {filterContent}
                    </div>
                    <div className="p-2">
                        {gridContent}
                    </div>
                </div>
                <CModal size="xl" backdrop="static" alignment="center" visible={modal} onClose={() => setModal(false)}>
                    <CModalBody>
                        <BettingDetail betting={selectedRow} close={() => setModal(false)} />
                    </CModalBody>
                </CModal>
            </>
        );
    }

    return (
        <>
            <StandardListPage title="미니게임 배팅" loading={loading} filterContent={filterContent}>
                {gridContent}
            </StandardListPage>
            <CModal size="xl" backdrop="static" alignment="center" visible={modal} onClose={() => setModal(false)}>
                <CModalBody>
                    <BettingDetail betting={selectedRow} close={() => setModal(false)} />
                </CModalBody>
            </CModal>
        </>
    )
}

const mapStateToProps = (state) => {
    const {account, store} = state;
    return { account, store }
}

export default connect(mapStateToProps, null)(MinigameBettingList);
